/* LEHUA · Recently Viewed
   - Trackeia handle de PDP visitada em localStorage (max 20)
   - Renderiza section [data-lehua-recently] com fetch /products/<handle>.js */

(function () {
  'use strict';

  const STORAGE_KEY = 'lehua_recently_viewed';
  const MAX_TRACKED = 20;

  function getList() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (_) { return []; }
  }

  function saveList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_TRACKED))); } catch (_) {}
  }

  function trackCurrentProduct() {
    const m = location.pathname.match(/^\/products\/([^\/?#]+)/);
    if (!m) return;
    const handle = m[1];
    let list = getList();
    list = list.filter(h => h !== handle);
    list.unshift(handle);
    saveList(list);
  }

  function fmtMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function buildCard(product) {
    const img = product.featured_image || (product.images && product.images[0]) || '';
    const imgSrc = typeof img === 'string' ? img : (img && img.src) || '';
    const price = fmtMoney(product.price);
    return (
      '<a class="lehua-recently__card" href="' + product.url + '">' +
        '<div class="lehua-recently__card-media">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="lehua-recently__card-name">' + product.title + '</div>' +
        '<div class="lehua-recently__card-price">' + price + '</div>' +
      '</a>'
    );
  }

  async function renderSection(section) {
    const limit = parseInt(section.dataset.limit || '6', 10);
    const currentHandle = section.dataset.currentHandle;
    const grid = section.querySelector('[data-lehua-recently-grid]');
    if (!grid) return;

    const handles = getList()
      .filter(h => h !== currentHandle)
      .slice(0, limit);

    if (!handles.length) {
      section.hidden = true;
      return;
    }

    const fetches = handles.map(h =>
      fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(r => r.ok ? r.json() : null)
        .catch(() => null)
    );
    const products = (await Promise.all(fetches)).filter(Boolean);

    if (!products.length) {
      section.hidden = true;
      return;
    }

    grid.innerHTML = products.map(buildCard).join('');
    section.hidden = false;
  }

  function init() {
    trackCurrentProduct();
    const sections = document.querySelectorAll('[data-lehua-recently]');
    sections.forEach(s => renderSection(s));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
